/**
 * About
 *
 * Example: Scripts for the About Page.
 *
 * @since 1.0.0
 */

// import $ from 'jquery';

export default {
  init() {
    // JavaScript to be fired on the about us page
  },
  finalize() {
    // JavaScript to be fired on the about page, after the init JS
  },
};
